import { combineReducers } from 'redux';
import stores from './bond-renewal/stores';
import storesCount from './bond-renewal/stores-count';
import isLoading from './bond-renewal/loading-status';

const bondRenewal = combineReducers({
  stores,
  storesCount,
  isLoading,
});

export default bondRenewal;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/bond-renewal.reducer.js